import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useRegistrationStatusChartsDataContext } from './hooks/useRegistrationStatusChartsDataContext';

export const RegistrationStatus = () => {
    const { chartData } = useRegistrationStatusChartsDataContext();

    return (
        <Donut
            title={'Situação Cadastral'}
            subtitles={chartData?.registrationStatus?.map((item) => item.description)}
            chartData={chartData?.registrationStatus || []}
            colors={defaultColors.slice(0, chartData?.registrationStatus?.length) || []}
            height={350}
            className="aligned-container"
        />
    );
};
